var workshop_accordion = (function( $ ) {

	var _init = function() {
		_toggle_open()
	};

	var _toggle_open = function() {
		const $workshop_icon = $( '.workshop-icon' );

		$workshop_icon.on( 'click', function( event ) {
			const dataIndex = $( this ).data( 'index' );
			const totalPointsAccordion = $( '.total-points-accordion[data-index="' + dataIndex + '"]' );
			$( '.workshop-icon[data-index="' + dataIndex + '"]' ).toggleClass( 'rotate' );

			totalPointsAccordion.slideToggle();
		} );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = workshop_accordion;